/**
 * @generated SignedSource<<168fc603802c2ffac388d52c678bf717>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeHeaderFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly appCustomization: {
          readonly backgroundImage: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoSideNavFragment_club">;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BookButtonHomeHeader_session">;
  readonly " $fragmentType": "HomeHeaderFragment_session";
};
export type HomeHeaderFragment_session$key = {
  readonly " $data"?: HomeHeaderFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeHeaderFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeHeaderFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookButtonHomeHeader_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FacilityLogoSideNavFragment_club"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AppCustomization",
                  "kind": "LinkedField",
                  "name": "appCustomization",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "backgroundImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "ccf6b25ded7d613d8ec3f6153026b526";

export default node;
